import { StepperInput } from 'foundations-components/transitional/components/StepperInput';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { useDebouncedOnChange } from '../hooks/useDebouncedOnChange';
import { jsx as _jsx } from "react/jsx-runtime";
function MarginInput(props) {
  const {
    value,
    onChange
  } = props;
  const [handleInputChange, handleStepChange] = useDebouncedOnChange(onChange);
  if (typeof value !== 'number') {
    return /*#__PURE__*/_jsx(TextInput, {
      minInlineSize: "0px",
      disabled: true,
      value: value,
      onChange: handleInputChange,
      size: 7
    });
  }
  return /*#__PURE__*/_jsx(StepperInput, {
    min: 0,
    max: 999,
    stepSize: 1,
    size: 3,
    value: value,
    onChange: handleInputChange,
    onStep: handleStepChange
  });
}
MarginInput.displayName = 'MarginInput';
export default MarginInput;